import React from 'react';
import { Header, Icon, List, Popup, Table } from 'semantic-ui-react';
import Campo from './Campo';

interface AlumnoDatos {
    nombreCompleto: string;
    numeroContrato: number;
    rutPasaporte: string;
    area:
        | 'preu'
        | 'ingles'
        | 'aleman'
        | 'japones'
        | 'coreano'
        | 'frances'
        | 'portugues'
        | 'fotografia';
    plan: 'anual' | 'invierno' | 'intensivo' | 'intensivo-vespertino';
    movil: string;
    correo: string;
    contactoDeEmergencia: {
        nombre: string;
        relacionConAlumno: string;
        telefonos: Array<{
            nombre: string;
            codArea: string;
            numero: string;
            whatsApp: boolean;
        }>;
    };
}

const AREAS = {
    preu: 'Preu',
    ingles: 'Inglés',
    aleman: 'Alemán',
    japones: 'Japonés',
    coreano: 'Coreano',
    frances: 'Francés',
    portugues: 'Portugués',
    fotografia: 'Fotografía',
};

const PLANES = {
    'anual': 'Anual',
    'invierno': 'Invierno',
    'intensivo': 'Intensivo',
    'intensivo-vespertino': 'Intensivo',
};

interface TablaAlumnosDeApoderadoProps {
    alumnos: AlumnoDatos[];
}
const TablaAlumnosDeApoderado: React.FunctionComponent<TablaAlumnosDeApoderadoProps> = props => {
    const { alumnos } = props;
    return (
        <div>
            <Header as='h4'>Alumnos</Header>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Contrato</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Rut/Pasaporte</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Área</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Plan</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Móvil</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center'>Correo</Table.HeaderCell>
                        <Table.HeaderCell textAlign='center' />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {alumnos.map(alumno => (
                        <Table.Row key={alumno.numeroContrato}>
                            <Table.Cell width='4' textAlign='center'>
                                {alumno.nombreCompleto}
                            </Table.Cell>
                            <Table.Cell width='1' textAlign='center'>
                                {alumno.numeroContrato}
                            </Table.Cell>
                            <Table.Cell width='2' textAlign='center'>
                                {alumno.rutPasaporte}
                            </Table.Cell>
                            <Table.Cell width='1' textAlign='center'>
                                {AREAS[alumno.area]}
                            </Table.Cell>
                            <Table.Cell width='1' textAlign='center'>
                                {PLANES[alumno.plan]}
                            </Table.Cell>
                            <Table.Cell width='3' textAlign='center'>
                                {alumno.movil.length > 0 ? '+569 ' + alumno.movil : ''}
                            </Table.Cell>
                            <Table.Cell width='4' textAlign='center'>
                                <a href={'mailto:' + alumno.correo}>{alumno.correo}</a>
                            </Table.Cell>
                            <Table.Cell width='1' textAlign='center'>
                                <Popup
                                    trigger={<Icon name='ellipsis horizontal' />}
                                    hideOnScroll
                                    hoverable
                                >
                                    <Popup.Header>Contacto de emergencia</Popup.Header>
                                    <Popup.Content>
                                        <List>
                                            <List.Item>
                                                Nombre: <b>{alumno.contactoDeEmergencia.nombre}</b>
                                            </List.Item>
                                            <List.Item>
                                                Relación con alumno:{' '}
                                                <b>
                                                    {alumno.contactoDeEmergencia.relacionConAlumno}
                                                </b>
                                            </List.Item>
                                            <List.Item>
                                                {alumno.contactoDeEmergencia.telefonos.map(
                                                    ({ nombre, codArea, numero }) =>
                                                        numero.length > 0 && (
                                                            <Campo
                                                                key={nombre}
                                                                etiqueta={'Teléfono ' + nombre}
                                                                valor={`+56${codArea} ${numero}`}
                                                            />
                                                        ),
                                                )}
                                            </List.Item>
                                        </List>
                                    </Popup.Content>
                                </Popup>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

export default TablaAlumnosDeApoderado;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/TablaAlumnosDeApoderado.tsx